export default __webpack_public_path__ + "static/media/subiracuerdoFE.1bd8c444.svg";